<template>
  <v-btn
    outlined
    :small="btnSmall"
    :block="btnBlock"
    :to="url"
    color="primary"
  >
    Enviar mensagem
  </v-btn>
</template>

<script>
export default {
  name: 'BtnEnviarMensagem',

  props: {
    idTransacao: {
      type: Number,
      required: true,
    },
    btnBlock: {
      type: Boolean,
      default: false,
    },
    btnSmall: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    url() {
      return `/chat/${this.idTransacao}`;
    },
  },
};
</script>
